import { render } from "./AddAccountModal.vue?vue&type=template&id=2dbad6f4&scoped=true"
import script from "./AddAccountModal.vue?vue&type=script&lang=js"
export * from "./AddAccountModal.vue?vue&type=script&lang=js"

import "./AddAccountModal.vue?vue&type=style&index=0&id=2dbad6f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbad6f4"]])

export default __exports__